/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CarrierService
 */
export interface CarrierService {
  /**
   *
   * @type {string}
   * @memberof CarrierService
   */
  carrierIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierService
   */
  serviceIdentifier?: string;
}

/**
 * Check if a given object implements the CarrierService interface.
 */
export function instanceOfCarrierService(
  value: object,
): value is CarrierService {
  return true;
}

export function CarrierServiceFromJSON(json: any): CarrierService {
  return CarrierServiceFromJSONTyped(json, false);
}

export function CarrierServiceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierService {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    serviceIdentifier:
      json["serviceIdentifier"] == null ? undefined : json["serviceIdentifier"],
  };
}

export function CarrierServiceToJSON(json: any): CarrierService {
  return CarrierServiceToJSONTyped(json, false);
}

export function CarrierServiceToJSONTyped(
  value?: CarrierService | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    serviceIdentifier: value["serviceIdentifier"],
  };
}
